import { PiSquaresFour, PiArrowRight } from "react-icons/pi";

const MetricCard = ({ value, label, subtitle, iconColor = "bg-blue-500", showArrow = true }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative">
      {showArrow && (
        <button className="absolute top-6 right-6 text-gray-400 hover:text-gray-600">
          <PiArrowRight className="w-5 h-5" />
        </button>
      )}
      
      <div className="flex items-start gap-4 mb-6">
        <div className={`${iconColor} rounded-xl p-3 flex items-center justify-center`}>
          <PiSquaresFour className="w-6 h-6 text-white" />
        </div>
        <div>
          <div className="text-4xl font-bold text-black">{value}</div>
          <div className="text-sm text-gray-500 mt-1">{label}</div>
        </div>
      </div>
      
      {subtitle && (
        <div className="pt-4 border-t border-gray-100">
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
      )}
    </div>
  );
};

export default MetricCard;
